import React from 'react';
import PropTypes from 'prop-types';

import {Badge, FormGroup} from "react-bootstrap";


class ProductFieldListDetails extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchVal: '',
            searchStatus: ''
        }
    }

    setSearchVal = val => {
        this.setState({searchVal: val.target.value, searchStatus: ''});
    };

    search() {
        const field = this.props.product[this.props.field];

        if(field.includes(this.state.searchVal)) {
            this.setState({searchStatus: 'success'});
        } else {
            this.setState({searchStatus: 'error'});
        }
    }

    renderValues() {
        if(!this.props.product) {
            return (
                <p>Aucuns éléments dans cette liste.</p>
            )
        }

        const field = this.props.product[this.props.field];

        let list = [];
        if(field) {
            list = field.split(',');
        }

        if(list.length) {
            return list.map((val, i) => {
                return (
                    <Badge key={i}>{val}</Badge>
                );
            });
        } else {
            return (
                <p>Aucuns éléments dans cette liste.</p>
            )
        }

    }

    render() {
        const inputColor = this.state.searchStatus === 'success' ? '#87cb16' : '#fb404b';

        return (
            <div>
                <div>
                    <FormGroup>
                        <input
                            style={this.state.searchStatus ? {border: `2px solid ${inputColor}`} : {}}
                            className="form-control"
                            placeholder="Substance à chercher"
                            type="text"
                            onChange={this.setSearchVal}
                            value={this.state.searchVal}
                            onKeyPress={(target) => {if(target.charCode === 13) this.search()}}
                        />
                    </FormGroup>
                </div>
                <div className="text-center">
                    {this.renderValues()}
                </div>
            </div>
        );
    }
}

ProductFieldListDetails.propTypes = {

    field: PropTypes.string,
    product: PropTypes.object

};

export default ProductFieldListDetails;